// extracted by mini-css-extract-plugin
export default {"parentLayout":"Layout_parentLayout__h-7oE"};